import { from, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { CORE_CONFIG } from '../../config/core-config';
import { StorageService } from '../../storage/storage.service';

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const config = inject(CORE_CONFIG);
  const storage = inject(StorageService);

  return from(storage.get(config.tokenKey)).pipe(
    switchMap((token) => {
      if (!request.url.includes(config.apiBaseUrl)) {
        return next(request);
      }

      if (token) {
        request = request.clone({
          headers: request.headers.set('Authorization', 'Bearer ' + token),
        });
      }

      if (!request.headers.has('Content-Type')) {
        request = request.clone({
          headers: request.headers.set('Content-Type', 'application/json'),
        });
      }

      return next(request).pipe(
        map((event: HttpEvent<unknown>) => {
          return event;
        })
      );
    })
  );
};
